// // dashboard-frontend/src/components/VolunteerLogin.jsx
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { fetchJSON } from '../api';
// import logo from '../assets/logo.png';

// const VolunteerLogin = () => {
//   const [usernameOrEmail, setUsernameOrEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const data = await fetchJSON('/api/users/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ usernameOrEmail, password })
//       });
      
//       // Check that user is a volunteer
//       if (data && data.user && data.user.role === 'volunteer') {
//         if (data.token) {
//           localStorage.setItem("token", data.token);
//         }
//         localStorage.setItem("volunteer", JSON.stringify(data.user));

//         // If firstTime is true, navigate to unified password update page
//         if (data.firstTime) {
//           navigate("/user/update-password");
//         } else {
//           navigate("/volunteer/dashboard");
//         }
//       } else {
//         alert("Invalid credentials or you are not a volunteer");
//       }
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gradient-to-br from-gray-100 to-gray-200">
//       <header className="mb-8 flex flex-col items-center">
//         <img src={logo} alt="JivDaya Trust Logo" className="w-24 h-24" />
//         <h4 className="mt-4 text-4xl font-extrabold text-primary">
//           Shri Jivdaya Mandal Bhachau
//         </h4>
//         <p className="mt-1 text-lg text-primary">
//           managed by Shri Kanaksuri Ahinsadham Bhachau
//         </p>
//       </header>
//       <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
//         <h2 className="text-2xl font-bold mb-6 text-gray-800">Volunteer Login</h2>
//         <div className="mb-4 text-left">
//           <label className="block text-gray-700 font-medium mb-1">Username or Email</label>
//           <input
//             type="text"
//             value={usernameOrEmail}
//             onChange={(e) => setUsernameOrEmail(e.target.value)}
//             className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:border-primary transition-colors"
//             required
//           />
//         </div>
//         <div className="mb-6 text-left">
//           <label className="block text-gray-700 font-medium mb-1">Password</label>
//           <input
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:border-primary transition-colors"
//             required
//           />
//         </div>
//         <button
//           type="submit"
//           className="w-full bg-primary text-white py-2 rounded hover:bg-secondary transition-colors"
//         >
//           Login
//         </button>
//       </form>
//     </div>
//   );
// };

// export default VolunteerLogin;




// dashboard-frontend/src/components/VolunteerLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchJSON } from '../api';
import logo from '../assets/logo.png';

const VolunteerLogin = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await fetchJSON('/api/users/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usernameOrEmail, password })
      });
      
      // Check that user is a volunteer
      if (data && data.user && data.user.role === 'volunteer') {
        if (data.token) {
          localStorage.setItem("token", data.token);
        }
        localStorage.setItem("volunteer", JSON.stringify(data.user));

        // If firstTime is true, navigate to unified password update page
        if (data.firstTime) {
          navigate("/user/update-password");
        } else {
          navigate("/volunteer/dashboard");
        }
      } else {
        alert("Invalid credentials or you are not a volunteer");
      }
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gradient-to-br from-gray-100 to-gray-200">
      <header className="mb-8 flex flex-col items-center">
        <img src={logo} alt="JivDaya Trust Logo" className="w-24 h-24" />
        <h4 className="mt-4 text-4xl font-extrabold text-primary">
          Shri Jivdaya Mandal Bhachau
        </h4>
        <p className="mt-1 text-lg text-primary">
          managed by Shri Kanaksuri Ahinsadham Bhachau
        </p>
      </header>

      <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Volunteer Login</h2>

        <div className="mb-4 text-left">
          <label className="block text-gray-700 font-medium mb-1">Username or Email</label>
          <input
            type="text"
            value={usernameOrEmail}
            onChange={(e) => setUsernameOrEmail(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:border-primary transition-colors"
            required
          />
        </div>

        <div className="mb-6 text-left">
          <label className="block text-gray-700 font-medium mb-1">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:border-primary transition-colors"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-primary text-white py-2 rounded hover:bg-secondary transition-colors"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default VolunteerLogin;
